import { httpRequest } from '@/services/httpClient'

export type CountryLookup = {
  id: number
  iso2: string
  iso3: string
  phoneCode: string | null
  isActive: boolean
  name: string
}

export type CityLookup = {
  id: number
  countryId: number
  name: string
  isActive: boolean
}

export type TownLookup = {
  id: number
  cityId: number
  name: string
  isActive: boolean
}

export type LanguageLookup = {
  id: number
  code: string
  isActive: boolean
  name: string
}

export type TimezoneLookup = {
  id: number
  iana: string
  utcOffset: string
  isActive: boolean
}

export const lookupsApi = {
  getCountries: (params?: { lang?: string }) =>
    httpRequest<CountryLookup[]>('/v1/lookups/countries', {
      method: 'GET',
      query: { onlyActive: true, ...params },
    }),

  getCities: (countryId: number, params?: { lang?: string }) =>
    httpRequest<CityLookup[]>('/v1/lookups/cities', {
      method: 'GET',
      query: { countryId, onlyActive: true, ...params },
    }),

  getTowns: (cityId: number, params?: { lang?: string }) =>
    httpRequest<TownLookup[]>('/v1/lookups/towns', {
      method: 'GET',
      query: { cityId, onlyActive: true, ...params },
    }),

  getLanguages: (params?: { lang?: string }) =>
    httpRequest<LanguageLookup[]>('/v1/lookups/languages', {
      method: 'GET',
      query: { onlyActive: true, ...params },
    }),

  getTimezones: () =>
    httpRequest<TimezoneLookup[]>('/v1/lookups/timezones', {
      method: 'GET',
      query: { onlyActive: true },
    }),
}
